import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Theme, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import * as firebase from 'firebase';
import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { compose } from 'redux';
import firebaseApp from '../../firebase';

const styles = (theme: Theme) => ({
  card: {
    marginTop: `100px`,
    maxWidth: `400px`,
    width: `90%`,
  },
  root: {
    alignItems: `center`,
    display: `flex`,
    flexDirection: 'column' as 'column',
  },
  textField: {
    width: `100%`,
  },
});

export interface IProps {
  classes: any;
}

interface IState {
  email: string;
  loading: boolean;
  password: string;
  errorMsg: string | null;
}

class Authentication extends React.Component<IProps & InjectedTranslateProps> {
  public state: IState;

  constructor(props: any) {
    super(props);
    this.state = {
      email: '',
      errorMsg: null,
      loading: false,
      password: '',
    };
  }

  public render() {
    const { classes, t } = this.props;
    const { errorMsg, loading } = this.state;

    return (
      <div className={classes.root}>
        <Card className={classes.card}>
          <form action="#" onSubmit={this.handleLogin}>
            <CardContent>
              <Typography variant="headline" component="h2">
                {t('cms_headline_sign_in')}
              </Typography>

              <TextField
                id="email"
                label={t('cms_label_email_address')}
                className={classes.textField}
                value={this.state.email}
                onChange={this.handleChange('email')}
                margin="normal"
                type="email"
                disabled={loading}
              />

              <TextField
                id="password"
                label={t('cms_label_password')}
                className={classes.textField}
                value={this.state.password}
                onChange={this.handleChange('password')}
                margin="normal"
                type="password"
                disabled={loading}
              />

              {errorMsg ? <p>{errorMsg}</p> : null}
            </CardContent>

            <CardActions>
              <Button
                onClick={this.handleLogin}
                disabled={loading}
                type="submit"
              >
                {t('cms_button_submit')}
              </Button>
            </CardActions>
          </form>
        </Card>
      </div>
    );
  }

  private handleChange = (name: string) => (event: any) => {
    this.setState({
      [name]: event.target.value,
      errorMsg: null,
    });
  };

  private handleLogin = (e: any) => {
    e.preventDefault();
    this.setState({ loading: true });

    firebaseApp
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .catch((err: firebase.FirebaseError) => {
        // console.log('[.handleLogin] LOGIN ERROR: ', err.code, err.message);

        this.setState({ errorMsg: err.message, loading: false });
      });
  };
}

const enhance = compose(translate(), withStyles(styles));

export default enhance(Authentication);



// WEBPACK FOOTER //
// ./src/auth/components/Authentication.tsx